import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { useState } from "react";
import { useEffect } from "react";

const AddStencil = ({ originalNSD, currentUser, data, inspectionDetail, inspectionId, handleClick, debouncedValue, setLoadingValue, retreadNSD }) => {
  const [hubs, setHubs] = useState([]);
  const [oldStencilNo, setOldStencilNo] = useState(data?.stencilNo)
  const previousG4 = parseFloat(inspectionDetail?.G4 || 100)
  const previousG2 = parseFloat(inspectionDetail?.G2 || 100)  
  const previousG1 = parseFloat(inspectionDetail?.G1 || 100)
  const previousG3 = parseFloat(inspectionDetail?.G3 || 100)
  const [loading, setLoading] = useState(false);
  // console.log({currentUser})

  const owners = ["JK", "FLEET"];
  const allStatus = [
    {
        value: "SCRAP",
        label: "SRP"
    },
    {
        value: "REUSE",
        label: "RSU"
    },
    {
        value: "REPAIR",
        label: "CTR"
    },
    {
        value: "MISSING",
        label: "MIS"
    },
    {
        value: "CASING",
        label: "CS1"
    },
    {
      value: "RETREAD",
      label: "RTD"
    },
    {
        value: "READY_TO_FIT_OUT",
        label: "ITM"
    },
  ]
  const retreadStatuses = [
    {
        value: "CASING",
        label: "CS1"
    },
    {
      value: "RETREAD",
      label: "RTD"
    },
  ]
  const queryClient = useQueryClient();
  // const { data: allFleets } = useQuery([`/customer-fleet`], () =>
  //   getAllData("/customer-fleet", {
  //     limit: 3000,
  //     page: 1,
  //   })
  // );
  const { data: scrapReasons } = useQuery([`/scrap-reasons`], () =>
    getAllData("/scrap-reason", {
    })
  );
  // const { data: allHubs } = useQuery([`/customer-hub`], () =>
  //   getAllData("/customer-hub", {
  //     limit: 3000,
  //     page: 1,
  //   })
  // );

  console.log('data--',data);

  const formik = useFormik({
    initialValues: {
      stencilNo: data?.stencilNo || "",
      newStencilNo: data?.stencilNo || "",
      hub: data?.hub?._id || "",
      fleet: data?.fleet?._id || "",
      tyreType: data.tyreType,
      owner: (data?.owner  ? data.owner : data?.isGrnTyre ? "JK" : "FLEET" )|| "",
      G1: data?.G1 ? data.G1 : originalNSD ,
      G2: data?.G2 ? data.G2 : originalNSD ,
      G3: data?.G3 ? data.G3 : originalNSD ,
      G4: data?.G4,
      averageNSD: data?.averageNSD,
      status: data?.status,
      scrapReason: data?.scrapReason,
      scrapReasonName: data?.scrapReasonName,
      inspectionId: inspectionId,
      canBeRevalidated:data?.canBeRevalidated??false,
      isValidated:data?.isValidated??false,
      soldOut: data?.soldOut ?? false,
    },
    onSubmit: async (values) => {
      setLoading(true);
      setLoadingValue(true);
      console.log("Invalidating stencils query...");
      Object.keys(values).forEach((key) => {
        if (values[key] === "") {
          delete values[key];
        }
      });

      if(data.status === "RETREAD" && values.status === "RETREAD"){
        delete values.status
      }
      delete values.tyreType;
      if(values.status!== "SCRAP"){
        values.scrapReason = null;
        values.scrapReasonName = null;
      }
      // if(values["stencilNo"] === oldStencilNo){
      //   delete values["stencilNo"]
      // }
      if(values["G4"] === undefined || values["G4"] === null || values["G4"] === "" || values["G4"] === "0" || values["G4"] === 0)
      values["averageNSD"] = String(parseFloat((parseFloat(values["G1"]) + parseFloat(values["G2"]) + parseFloat(values["G3"]))/3).toFixed(2));
      else
      values["averageNSD"] = String(parseFloat((parseFloat(values["G1"]) + parseFloat(values["G2"]) + parseFloat(values["G3"]) + parseFloat(values["G4"]))/4).toFixed(2));
      // console.log({values})
      const response = await updateDocumentByID("tyre/update", data._id, {...values, inspectionId});
      if(response) toast.success(response.message);
      handleClick();
      await queryClient.invalidateQueries(["stencils", debouncedValue && debouncedValue]);
      console.log("Query invalidated");
      setLoadingValue(false)
    },

    validate: (values) => {
      const errors = {};

      console.log("Check", values.G1, originalNSD, retreadNSD, values.tyreType, values.status, parseFloat(values.G1) > originalNSD)
      if (!values.G1) errors.G1 = "Required";
      if (!values.G2) errors.G2 = "Required";
      if (!values.G3) errors.G3 = "Required";
      // if (!values.G4) errors.G4 = "Required";
      if (currentUser?.userRole?.name !== "SUPER_ADMIN" && (values.status !== "RETREAD" && !values.isValidated && parseFloat(values.G4) > previousG4))
        errors.G4 = "Cannot be Greater than previous G4"
      else if (parseFloat(values.G4) > originalNSD || (/RTD/.test(values.tyreType) && values.G4 > retreadNSD))
        errors.G4 = `Cannot be Greater than ${originalNSD}`

      if (currentUser?.userRole?.name !== "SUPER_ADMIN" && (values.status !== "RETREAD" && !values.isValidated && parseFloat(values.G3) > previousG3))
        errors.G3 = "Cannot be Greater than previous G3"
      else if (parseFloat(values.G3) > originalNSD || (/RTD/.test(values.tyreType) && values.G3 > retreadNSD))
        errors.G3 = `Cannot be Greater than ${originalNSD}`

      if (currentUser?.userRole?.name !== "SUPER_ADMIN" && (values.status !== "RETREAD" && !values.isValidated && parseFloat(values.G2) > previousG2))
        errors.G2 = "Cannot be Greater than previous G2"
      else if (parseFloat(values.G2) > originalNSD || (/RTD/.test(values.tyreType) && values.G2 > retreadNSD))
        errors.G2 = `Cannot be Greater than ${originalNSD}`

      if (currentUser?.userRole?.name !== "SUPER_ADMIN" && (values.status !== "RETREAD" && !values.isValidated && parseFloat(values.G1) > previousG1))
        errors.G1 = "Cannot be Greater than previous G1"
      else if (parseFloat(values.G1) > originalNSD || (/RTD/.test(values.tyreType) && parseFloat(values.G1) > retreadNSD))
        errors.G1 = `Cannot be Greater than ${originalNSD}`

      if(values.status === "SCRAP" & !values.scrapReason) errors.scrapReason = "Required"

      // if (values.stencilNo && values.stencilNo.length > 11)
      //   errors.stencilNo = "max 11 digits is allowed";
      // if (
      //   values.stencilNo &&
      //   values.stencilNo.length <= 11 &&
      //   /^([a-zA-Z0-9 _-]+)$/.test(values.stencilNo) === false
      // )
      //   errors.stencilNo = "only digits and characters are allowed";
      if (values.G1 && /^\d*(\.\d+)?$/.test(values.G1) === false)
        errors.G1 = "Enter a valid number G1";
      if (values.G2 && /^\d*(\.\d+)?$/.test(values.G2) === false)
        errors.G2 = "Enter a valid number G2";
      if (values.G3 && /^\d*(\.\d+)?$/.test(values.G3) === false)
        errors.G3 = "Enter a valid number G3";
      if (values.G4 && /^\d*(\.\d+)?$/.test(values.G4) === false)
        errors.G4 = "Enter a valid number G4";
      //   if (!values.fleet) errors.fleet = "Required";
      return errors;
    },
  });

  console.log('formik.values.status',formik.values.status);

  return (
    <Model
      handleClick={handleClick}
      title={data ? "Update Stencil" : "Add Stencil"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
       
            <label className="py-3">
            Select Owner
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={owners.map((status) => ({
                value: status,
                label: status,
              }))}
              value={{
                value: formik.values.owner ,
                label: owners.find((d) => d === formik.values.owner),
              }}
              onChange={(value) => {
                formik.setFieldValue("owner", value.value);
              }}
              name="owner"
              placeholder="Select Owner"
              isDisabled={!(["SUPER_ADMIN"].includes(currentUser?.userRole?.name))}
            />
            {formik.touched.fleet && formik.errors.fleet ? (
              <p className="text-red-500 font-normal">*{formik.errors.fleet}</p>
            ) : null}
          </label>

          {<InputField 
          desable = {!(["SUPER_ADMIN"].includes(currentUser?.userRole?.name))} 
           type="text" label="Stencil Number" name="newStencilNo" />}
           
          {data?.status!== "FITTED" && <label className="py-3">
            Tyre Location / Status
            <ReactSelect
            // isDisabled={data?.isValidated}
            options={["CASING", "RETREAD"].includes(formik.values.status) || /RTD/.test(formik.values.tyreType) ? allStatus.filter(item => item.value!= "READY_TO_FIT_OUT") : allStatus}
            value={{
              value: formik.values.status,
              label: allStatus?.find((d) => d?.value === formik.values.status)?.label,
            }}
              onChange={(value) => {
                if(value.value === "RETREAD"){
                  formik.setFieldValue("G1", data.retreadNSD)
                  formik.setFieldValue("G2", data.retreadNSD)
                  formik.setFieldValue("G3", data.retreadNSD)
                  if(data.G4) formik.setFieldValue("G4", data.retreadNSD)
                  formik.setFieldValue("averageNSD", data.retreadNSD)
                }
                formik.setFieldValue("status", value.value);
              }}
              name="status"
              isMulti={false}
            />
            {formik.touched.status && formik.errors.status && (
              <p className="text-red-500 font-normal">*{formik.errors.status}</p>
            )}
          </label>}

          {
            formik.values.status === "SCRAP" && 
            <label className="py-3">
            Select Scrap Reason
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={scrapReasons?.data?.map((item) => {
                // console.log(item);
                return {value: item._id,
                label: item.reason,}
              })}
              value={{
                value:  formik.values.scrapReason,
                label: scrapReasons?.data?.find(scrapReason => scrapReason._id ===   formik.values.scrapReason)?.reason,
              }}
              onChange={(value) => {
                // console.log(formik.values.scrapReasonName, scrapReasons?.data?.find(scrapReason => scrapReason._id ===   formik.values.scrapReason)?.reason)
                formik.setFieldValue("scrapReason", value.value);
                formik.setFieldValue("scrapReasonName", value.label)
              }}
              name="owner"
              placeholder="Select Scrap Reason"
              isMulti={false}
            />
            {formik.touched.scrapReason && formik.errors.scrapReason ? (
              <p className="text-red-500 font-normal">*{formik.errors.scrapReason}</p>
            ) : null}
          </label>
          }
          <InputField type="text" label="G1 NSD" name="G1" />
          <InputField type="text" label="G2 NSD" name="G2" />
          <InputField type="text" label="G3 NSD" name="G3" />
          <InputField type="text" label="G4 NSD" name="G4" />

          <div className="flex flex-row gap-x-6"> 

            {formik.values.isValidated ? <label className="flex flex-row gap-x-2 py-0 h-full h-6">
              <input type="checkbox" checked={formik.values.canBeRevalidated} value={formik.values.canBeRevalidated} onChange={(e) => { formik.setFieldValue("canBeRevalidated", e.target.checked) }} />
              {formik.values.canBeRevalidated}
              <span className="h-full justify-center align-middle "> Can Be Revalidated </span>
            </label> : <></>
}
          <label className = "flex flex-row gap-x-2 py-0 h-full h-6">
           <input type = "checkbox" checked = {formik.values.soldOut} value = {formik.values.soldOut}  disabled = {formik.values.status === "FITTED"}  onChange={(e)=>{formik.setFieldValue("soldOut", e.target.checked)}}/>
              {formik.values.soldOut}
            <span className = "h-full justify-center align-middle "> Sold </span>
          </label>

          </div>
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" disabled = {loading} bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddStencil;
